import React__default from 'react';

const width = 24;
const height = 24;
const IconBold = ({ fill = 'black', size = 1 }) => {
    return (React__default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: size * width, height: size * height, fill: "none", viewBox: "0 0 24 24" },
        React__default.createElement("path", { stroke: fill, strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2", d: "M8 5h4.5a3.5 3.5 0 1 1 0 7H8m0-7v7m0-7H6m2 7h6.5a3.5 3.5 0 1 1 0 7H8m0-7v7m0 0H6" })));
};

export { IconBold as default };
//# sourceMappingURL=IconBold.js.map
